import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";

const apiListesi = (value) => {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.$values)) return value.$values;
  return [];
};

const PrivateRoute = ({ children, allowedRoles = [], managerOnly = false }) => {
  const allowedRoleKey = allowedRoles.join("|");
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = loading
  const [isAuthorized, setIsAuthorized] = useState(
    allowedRoles.length === 0 && !managerOnly
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const gerekliRoller = allowedRoleKey ? allowedRoleKey.split("|") : [];
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/GetUserIdByToken`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        const authenticated = res.status === 200;
        setIsAuthenticated(authenticated);

        if (authenticated && managerOnly) {
          const mudurResponse = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/mudur/egitim-dashboard/erisim`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          const erisimVar = mudurResponse.data?.erisimVar === true;
          localStorage.setItem("magazaMuduruMu", erisimVar ? "true" : "false");
          setIsAuthorized(erisimVar);
        } else if (authenticated && gerekliRoller.length > 0) {
          const rolResponse = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/Rol/benimrollerim`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          const roller = apiListesi(rolResponse.data);
          localStorage.setItem("roles", JSON.stringify(roller));
          setIsAuthorized(gerekliRoller.some((rol) => roller.includes(rol)));
        }
      } catch (err) {
        setIsAuthenticated(false);
        setIsAuthorized(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [allowedRoleKey, managerOnly]);

  if (loading) return <div>Yükleniyor...</div>;

  if (!isAuthenticated) return <Navigate to="/" />;
  return isAuthorized ? children : <Navigate to="/profil" />;
};

export default PrivateRoute;
